import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { config } from '../../function/config'
import { toast } from 'react-toastify'
import ManagerHeader from './ManagerHeader'
import { useNavigate } from 'react-router-dom'
import { FaEdit, FaRedo, FaSearch, FaSyncAlt, FaTrashAlt, FaUserPlus } from 'react-icons/fa'

export default function AllAllocateBed() {
  const token = localStorage.getItem('token')
  const navigate = useNavigate()

  const [allocatedBed, setAllocatedBed] = useState([])
  const [filteredBeds, setFilteredBeds] = useState([])

  const [selectedBed, setSelectedBed] = useState(null)
  const [selectedType, setSelectedType] = useState('All')

  const fetchAllocatedBed = async() => {
    try{
        const res = await axios.get(`${config.baseurl}get_allocated_beds/`, {
            headers:{
                'Content-Type':'application/json',
                'Authorization':`Token ${token}`
            }
        })
        console.log('Allocated Bed Res:', res.data)

        if(res.status === 200){
            const data = res.data.data || []
            setAllocatedBed(data)
            setFilteredBeds(data)
        }else{
            toast.error('Failed to fetch allocated bed')
        }
    }catch(error){
        console.log('Error:', error.response?.data || error)

      const message =
        error.response?.data?.message ||
        error.response?.data?.error ||
        'Failed to create Department'

      toast.error(message)
    }
  }

  useEffect(() => {
    fetchAllocatedBed()
  },[token])
  console.log('Allocated bed:', allocatedBed)

  const handleSearch = () => {
    let result = [...allocatedBed]

    if(selectedType !== 'All'){
      result = result.filter(item => item.category === selectedType)
    }

    setFilteredBeds(result)
  }

  const handleReset = () => {

    setSelectedType('All')

    setFilteredBeds(allocatedBed)
  }

  const handleDelete = async(id) => {
    console.log('Allocated Bed Id:', id)

    if(!id){
        toast.error('Invalid Allocated bed id')
        return
    }

    try{
        const res = await axios.delete(`${config.baseurl}delete_allocated_bed/${id}/`, {
            headers:{
                'Content-Type':'application/json',
                'Authorization':`Token ${token}`
            }
        })

        toast.success('Allocated Bed Deleted successfully')
        await fetchAllocatedBed()
    }catch(error){
      console.error('Error:', error.response?.data || error)

      const message =
        error.response?.data?.message ||
        error.response?.data?.error ||
        'Failed to create Department'

      toast.error(message)
    }
  }

  return (
    <div className='min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-slate-100 ml-64 5xl:ml-0'>
        <ManagerHeader/>

        <div className='max-w-7xl mx-auto px-6 pt-16 pb-6 items-center justify-between text-center'>
        <h1 className='mt-1 text-3xl font-bold'>
            ALL Allocated Bed
        </h1>
        <p className="mt-2 text-sm text-slate-500">
            View and manage all registered Allocated Bed in one place.
        </p>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 pb-6">
            <div className="bg-white rounded-lg shadow-sm border border-slate-200 p-4 sm:p-5 mb-6">

                <div className="grid grid-cols-3 5xl:grid-cols-1 gap-4 items-center">

                    {/* Bed Type */}
                    <div>
                        <label className="text-sm font-medium text-slate-700">
                            Bed Type
                        </label>

                        <select
                            className="w-full border border-slate-300 rounded-md px-4 py-2.5 bg-white outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
                            value={selectedType}
                            onChange={(e) => setSelectedType(e.target.value)}
                        >
                            <option value="All">All</option>
                            <option value="Child">Child</option>
                            <option value="Aged Person">Aged Person</option>
                        </select>
                    </div>

                    {/* Search */}
                    <button
                        type="button"
                        onClick={handleSearch}
                        className="w-full flex items-center justify-center gap-2 px-2 py-2.5 border border-slate-300 rounded-md shadow-sm bg-blue-500 text-white hover:bg-blue-600 transition"
                    >
                        <FaSearch />
                    </button>

                    {/* Reset */}
                    <button
                        type="button"
                        onClick={handleReset}
                        className="w-full flex items-center justify-center gap-2 px-2 py-2.5 border border-slate-300 rounded-md shadow-sm bg-slate-300 text-slate-700 hover:bg-slate-400 transition"
                    >
                        <FaRedo />
                    </button>

                </div>
            </div>
        </div>

        <div className='max-w-7xl mx-auto px-6 pb-10'>
            <div className='bg-white rounded-lg shadow-sm border border-slate-300 overflow-hidden'>
                <div className='overflow-x-auto'>
                    <table className='w-full table-auto'>
                        <thead>
                            <tr className='text-center border-b border-slate-300'>
                            <th className='px-3 py-2 whitespace-nowrap'>No</th>
                            <th className='px-3 py-2 whitespace-nowrap'>Name</th>
                            <th className='px-3 py-2 whitespace-nowrap'>Bed Number</th>
                            <th className='px-3 py-2 whitespace-nowrap'>Bed Type</th>
                            <th className='px-3 py-2 whitespace-nowrap'>Action</th>
                            </tr>
                        </thead>

                        <tbody>
                            {filteredBeds.length > 0 ? (
                            filteredBeds.map((item, index) => (
                                <tr
                                key={item.id}
                                className='text-center border-b border-b-slate-300'
                                >
                                <td className='px-3 py-2 whitespace-nowrap'>{index + 1}</td>
                                <td className='px-3 py-2 whitespace-nowrap'>{item.new_admission_name}</td>
                                <td className='px-3 py-2 whitespace-nowrap'>{item.bed_number}</td>
                                <td className='px-3 py-2 whitespace-nowrap'>{item.category}</td>
                                <td className='px-3 py-2 whitespace-nowrap'>
                                    <div className='flex items-center justify-center gap-3'>
                                    <button
                                        title='Edit'
                                        onClick={() => {
                                        setSelectedBed(item)
                                        navigate(`/manager/edit_allocated_bed/${item.id}`)
                                        }}
                                        className='bg-blue-500 text-white px-3 py-2 rounded-lg hover:bg-blue-600'
                                    >
                                        <FaEdit/>
                                    </button>

                                    <button
                                        title='Delete'
                                        onClick={() => handleDelete(item.id)}
                                        className='bg-red-500 text-white px-3 py-2 rounded-lg hover:bg-red-600'
                                    >
                                        <FaTrashAlt/>
                                    </button>
                                    </div>
                                </td>
                                </tr>
                            ))
                            ) : (
                            <tr>
                                <td
                                colSpan={5}
                                className='text-center py-6'
                                >
                                No Data Found
                                </td>
                            </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
  )
}
